import Vue from 'vue'
import VueRouter from 'vue-router'
const Layout = () => import('@/views/Layout.vue')
const Login = () => import('@/views/Login.vue')
// const PersonnelReport = () => import('@/views/hr/PersonnelReport.vue')
// const AnnualAnalysis = () => import('@/views/hr/AnnualAnalysis.vue')
// const PersonnelAnalysis = () => import('@/views/hr/PersonnelAnalysis.vue')
// const ResignPersonnel = () => import('@/views/hr/ResignPersonnel.vue')
// const ResignDetail = () => import('@/views/hr/ResignDetail.vue')
// const AuditionList = () => import('@/views/audition/AuditionList.vue')
// const TransferIn = () => import('@/views/audition/TransferIn.vue')
// const AuditionDetail = () => import('@/views/audition/AuditionDetail.vue')
// const EditAudition = () => import('@/views/audition/EditAudition.vue')
// const TalentPool = () => import('@/views/audition/TalentPool.vue')
// const DataArchiving = () => import('@/views/audition/DataArchiving.vue')
// const AttendanceRules = () => import('@/views/attendance/AttendanceRules.vue')
// const AttendanceList = () => import('@/views/attendance/AttendanceList.vue')
// const ScheduleList = () => import('@/views/attendance/ScheduleList.vue')
// const UserList = () => import('@/views/user/UserList.vue')
// const EditPermission = () => import('@/views/user/EditPermission.vue')
// const MedicalCare = () => import('@/views/audition/MedicalCare.vue')
// const EditPassword = () => import('@/views/user/EditPassword.vue')


Vue.use(VueRouter)

export const constantRoutes = [
  { path: "/login", component: Login, name: 'Login' },
  {
    path: '/',
    component: Layout,
    redirect: '/personnel/personnelList',
    children: []
  },
  {
    path: '/interviewRegistration',
    name: 'interviewRegistration',
    component: () => import(`@/views/audition/InterviewRegistration.vue`),
  },
  {
    path: '*',
    component: () => import(`@/views/404.vue`),
  }


]


export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRoutes,
  // vue-router提供了scrollBehavior方法
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }

})